/** Structural constants (not balance tuning — that lives in balance.ts). */

export const FONT = {
  ui: 'Baloo 2',
  display: 'Rubik',
} as const;

/** Render order within a scene's world container (higher = on top). */
export const Depth = {
  floor: 0,
  decalLow: 5,
  obstacleShadow: 8,
  telegraph: 10,
  pickup: 15,
  corpse: 18,
  entityShadow: 20,
  entity: 30,
  projectile: 40,
  obstacle: 45,
  flyingFx: 60,
  healthBar: 70,
  damageNumber: 80,
} as const;

/** Collision/category bitflags (kept simple for the prototype). */
export const Team = {
  player: 0,
  enemy: 1,
} as const;
export type TeamId = (typeof Team)[keyof typeof Team];

/** Spatial hash cell size in world px. */
export const SPATIAL_CELL = 96;

/**
 * Vertical foreshortening of the ground plane to fake a tilted ("isometric"
 * 2.5D) camera like Brawl Stars / Diablo. The whole world container is scaled
 * by (1, CAMERA_TILT); upright objects (hero, enemies, projectiles, numbers)
 * counter-scale by 1/CAMERA_TILT so they stand at full height on the squashed
 * floor. Gameplay logic stays in flat top-down coordinates.
 */
export const CAMERA_TILT = 0.62;
export const INV_TILT = 1 / CAMERA_TILT;
